import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomeScreen from './screens/HomeScreen';
import DevotionalScreen from './screens/DevotionalScreen';
import EventsScreen from './screens/EventsScreen';
import DonateScreen from './screens/DonateScreen';
import ConnectScreen from './screens/ConnectScreen';
import HHTNoticeBoardScreen from './screens/HHTNoticeBoardScreen';
import AdminLoginScreen from './screens/AdminLoginScreen';
import AdminDashboardScreen from './screens/AdminDashboardScreen';
import AdminMessagesScreen from './screens/AdminMessagesScreen';
import { supabase } from './lib/supabase';
import { Session } from '@supabase/supabase-js';

export default function App() {
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/devotional" element={<DevotionalScreen />} />
        <Route path="/events" element={<EventsScreen />} />
        <Route path="/donate" element={<DonateScreen />} />
        <Route path="/connect" element={<ConnectScreen />} />
        <Route path="/notice-board" element={<HHTNoticeBoardScreen />} />
        <Route path="/admin-login" element={<AdminLoginScreen />} />
        <Route
          path="/admin-dashboard"
          element={session ? <AdminDashboardScreen /> : <Navigate to="/admin-login" />}
        />
        <Route
          path="/admin-messages"
          element={session ? <AdminMessagesScreen /> : <Navigate to="/admin-login" />}
        />
      </Routes>
    </Router>
  );
}
